import { css, styled } from '../theme'
import {
  alignmentCss,
  AlignmentProps,
  HorizontalMarginProps,
  horizontalMarginsCss,
  MarginDesktopProps,
  marginsDesktopCss,
  marginsTabletCss,
  MarginTabletProps,
  VerticalMarginProps,
  verticalMarginsCss,
} from '../theme/css'

export interface Props {
  className?: string
  onlyMobile?: boolean
  onlyDesktop?: boolean
  position?: 'absolute' | 'relative' | 'fixed' | 'sticky'
  flex?: boolean
  inline?: boolean
  alignCenter?: boolean
  relative?: Boolean
  grow?: number

  // v?lido s?lo con flex: true
  responsive?: boolean
  basis?: number | string
  shrink?: number
  justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly'
  align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline'
  wrap?: boolean
  direction?: 'row' | 'column'

  // Oculta el elemento por css en vez de programaticamente
  hideWithCss?: boolean
}

const justifyToValueMapping = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  between: 'space-between',
  around: 'space-around',
  evenly: 'space-evenly',
}

const alignToValueMapping = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  stretch: 'stretch',
  baseline: 'baseline',
}

const positionToValueMapping = {
  relative: 'relative',
  absolute: 'absolute',
  fixed: 'fixed',
  sticky: 'sticky',
}

export const Block = styled.div.attrs({})<
  Props &
    HorizontalMarginProps &
    VerticalMarginProps &
    AlignmentProps &
    MarginDesktopProps &
    MarginTabletProps
>`
  position: ${p =>
    p.relative ? 'relative' : p.position && positionToValueMapping[p.position]};
  display: ${p => p.inline && 'inline-block'};
  text-align: ${p => (p.alignCenter ? 'center' : null)};

  ${verticalMarginsCss};
  ${horizontalMarginsCss};
  ${marginsDesktopCss};
  ${marginsTabletCss};
  ${alignmentCss};

  ${p =>
    p.flex &&
    css`
      display: ${p.inline ? 'inline-flex' : 'flex'};

      align-items: ${p.alignCenter ? 'center' : null};
      align-items: ${p.align && alignToValueMapping[p.align]};
      justify-content: ${p.justify && justifyToValueMapping[p.justify]};

      flex-wrap: ${p.wrap && 'wrap'};
      flex-direction: ${p.direction && p.direction};
    `};

  flex-basis: ${p => p.basis && p.basis};
  flex-shrink: ${p => p.shrink && p.shrink};
  flex-grow: ${p => p.grow && p.grow};
  flex-basis: ${p => p.basis && p.basis};

  ${p => p.theme.media.onlyMobile`
    ${p.responsive && 'display: block'};
    ${p.onlyDesktop && p.hideWithCss && 'display: none'};
  `};

  ${p => p.theme.media.desktop`
    ${p.onlyMobile && p.hideWithCss && 'display: none'};
  `};
`
